// extracted by mini-css-extract-plugin
module.exports = {"gfoPaymentsContainer":"gfo-payments_gfoPaymentsContainer__3FfV_"};